import { render, staticRenderFns } from "./rider.vue?vue&type=template&id=0f3ec8ec&scoped=true&"
import script from "./rider.vue?vue&type=script&lang=js&"
export * from "./rider.vue?vue&type=script&lang=js&"
import style0 from "./rider.vue?vue&type=style&index=0&id=0f3ec8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3ec8ec",
  null
  
)

export default component.exports